var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3414_2178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 63V1H1V63H63Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3414_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6546 34.3582C12.9191 30.8502 11.2927 26.4389 11.2927 21.6449C11.2927 10.2069 20.5621 0.937684 31.9998 0.937684C36.0639 0.937684 39.8518 2.10706 43.0478 4.1303M46.3856 6.74867C50.2831 10.5153 52.7067 15.7948 52.7067 21.6449C52.7067 29.3833 48.4655 36.1297 42.1761 39.6837C41.2016 40.2329 40.6348 40.9947 40.6348 42.1463V47.2168H23.3648V42.1463C23.3648 41.0513 22.7447 40.2046 21.8163 39.6802C20.6711 39.0306 19.5903 38.2736 18.5885 37.4195",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1222 54.4273H40.6348C40.6348 59.1965 36.7691 63.0625 31.9998 63.0625C27.2305 63.0625 23.3647 59.1965 23.3647 54.4273H29.8774",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3647 54.4272V47.2168H40.6347V54.4272",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8632 47.2168L27.436 34.2447M36.5635 34.2447L34.1364 47.2168",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7223 7.84011C30.526 7.84011 32 9.31423 32 11.1142V30.9709C32 32.7744 30.526 34.2485 28.7223 34.2485C26.9225 34.2485 25.4485 32.7744 25.4485 30.9709V29.9504C24.7965 30.9318 23.6802 31.5769 22.4154 31.5769C20.4027 31.5769 18.7727 29.9469 18.7727 27.9377C18.7727 27.2858 18.9465 26.6764 19.2441 26.1449C16.9302 25.6028 15.2083 23.5229 15.2083 21.0424C15.2083 18.5622 16.9302 16.4825 19.2441 15.9402C18.9351 15.3932 18.7727 14.7755 18.7727 14.1472C18.7727 12.1382 20.4027 10.5084 22.4154 10.5084C23.6802 10.5084 24.7965 11.1534 25.4485 12.1347V11.1142C25.4485 9.31423 26.9225 7.84011 28.7223 7.84011Z",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2774 7.84011C33.4738 7.84011 31.9998 9.31423 31.9998 11.1142V30.9709C31.9998 32.7744 33.4738 34.2485 35.2774 34.2485C37.0774 34.2485 38.5512 32.7744 38.5512 30.9709V29.9504C39.2034 30.9318 40.3195 31.5769 41.5845 31.5769C43.5971 31.5769 45.227 29.9469 45.227 27.9377C45.227 27.2858 45.0533 26.6764 44.7556 26.1449C47.0695 25.6028 48.7915 23.5229 48.7915 21.0424C48.7915 18.5622 47.0695 16.4825 44.7556 15.9402C45.0647 15.3932 45.227 14.7755 45.227 14.1472C45.227 12.1382 43.5971 10.5084 41.5845 10.5084C40.3195 10.5084 39.2034 11.1534 38.5512 12.1347V11.1142C38.5512 9.31423 37.0774 7.84011 35.2774 7.84011Z",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.211 11.819C25.739 12.4497 26.0543 13.2612 26.0543 14.1469C26.0543 15.6423 25.1543 16.925 23.8682 17.4883",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7888 11.819C38.2608 12.4497 37.9456 13.2612 37.9456 14.1469C37.9456 15.6423 38.8456 16.925 40.1317 17.4883",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4482 20.8016C25.4482 22.6087 26.9151 24.0757 28.7221 24.0757C30.5329 24.0757 31.9997 22.6087 31.9997 20.8016",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5512 20.8016C38.5512 22.6087 37.0845 24.0757 35.2774 24.0757C33.4666 24.0757 31.9998 22.6087 31.9998 20.8016",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0349 26.584C19.3056 25.909 19.7723 25.3305 20.3748 24.9232C20.9773 24.5159 21.688 24.2983 22.4153 24.2986C22.8084 24.2986 23.1841 24.3589 23.5384 24.4759",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9647 26.584C44.6939 25.909 44.2273 25.3306 43.6248 24.9232C43.0223 24.5159 42.3117 24.2984 41.5844 24.2986C41.1946 24.2986 40.8156 24.3589 40.4612 24.4759",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCount);
export default __webpack_public_path__ + "static/media/smart-count.ab53a0d0177621f70cc01604b0f94d84.svg";
export { ForwardRef as ReactComponent };